import { useGetSdgLensBottomAreaLayout } from '../common/layout/bottom-area-layout';
import { SdgLensLegendMaybe } from './sdg-lens-legend';

export const SdgLensBottomArea = () => {
  const layout = useGetSdgLensBottomAreaLayout();
  if (!layout) return <></>;

  return (
    <>
      <SdgLensLegendMaybe legendAreaBoundsGetter={layout.getLegendAreaBounds} />
    </>
  );
};
